const BODY_LENGTH = [
  [0.032, 0.045, 0.055, 0.16, 0.32, 0.5, 1, 1.6],
  [0.036, 0.052, 0.065, 0.18, 0.36, 0.6, 1.1, 1.8],
  [0.045, 0.06, 0.075, 0.22, 0.45, 0.7, 1.4, 2.2],
  [0.055, 0.08, 0.095, 0.26, 0.55, 0.9, 1.8, 2.6],
  [0.075, 0.1, 0.13, 0.36, 0.75, 1.2, 2.4, 3.6],
  [0.1, 0.15, 0.18, 0.5, 1, 1.6, 3.2, 5],
  [0.15, 0.21, 0.26, 0.7, 1.5, 2.4, 4.8, 7]
]

const BODY_LENGTH_RANGE = {
  byS3D: [0.4, 0.63, 1, 1.6, 2.5, 4.1],
  byDWire: [0.31, 0.61, 1.5, 3.1, 6.1, 12.1, 25.1]
}

// Для пружины сжатия
const BODY_LENGTH_TYPE1 = [
  [0.16, 0.32, 0.5, 1, 1.6],
  [0.18, 0.36, 0.6, 1.1, 1.8],
  [0.22, 0.45, 0.7, 1.4, 2.2],
  [0.26, 0.55, 0.9, 1.8, 2.6],
  [0.36, 0.75, 1.2, 2.4, 3.6],
  [0.5, 1, 1.6, 3.2, 5],
  [0.7, 1.5, 2.4, 4.8, 7]
]

const BODY_LENGTH_RANGE_TYPE1 = {
  byS3D: [0.401, 0.631, 1.01, 1.609, 2.501, 4.09],
  byDWire: [3.1, 7, 14, 28]
}

const BODY_LENGTH_DWIRE_SPLIT_VALUE = 1.5

// Поиск c1 по длине, s3/d и диаметру (для сжатия, если диаметр меньше BODY_LENGTH_DWIRE_SPLIT_VALUE)
const BODY_LENGTH_FOR_S3 = [
  [
    [0.04, 0.035, 0.032, 0.03, 0.025],
    [0.11, 0.09, 0.045, 0.043, 0.04],
    [0.22, 0.12, 0.055, 0.052, 0.05]
  ],
  [
    [0.04, 0.035, 0.036, 0.03, 0.025],
    [0.12, 0.095, 0.052, 0.05, 0.045],
    [0.25, 0.15, 0.065, 0.06, 0.055]
  ],
  [
    [0.047, 0.046, 0.045, 0.038, 0.031],
    [0.14, 0.11, 0.06, 0.055, 0.05],
    [0.26, 0.16, 0.075, 0.07, 0.065]
  ],
  [
    [0.057, 0.056, 0.055, 0.047, 0.038],
    [0.14, 0.12, 0.08, 0.075, 0.07],
    [0.3, 0.18, 0.095, 0.09, 0.085]
  ],
  [
    [0.077, 0.076, 0.075, 0.064, 0.052],
    [0.15, 0.13, 0.1, 0.09, 0.08],
    [0.34, 0.2, 0.13, 0.11, 0.1]
  ],
  [
    [0.12, 0.11, 0.1, 0.095, 0.09],
    [0.22, 0.2, 0.15, 0.14, 0.13],
    [0.4, 0.25, 0.18, 0.17, 0.16]
  ],
  [
    [0.17, 0.16, 0.15, 0.14, 0.13],
    [0.27, 0.23, 0.21, 0.2, 0.19],
    [0.55, 0.35, 0.26, 0.25, 0.24]
  ]
]

const BODY_LENGTH_RANGE_FOR_S3 = {
  byS3D: [0.409, 0.64, 1.1, 1.7, 2.6, 4.1],
  byDWire: [0.36, 0.7, 1.5],
  byL0: [5.1, 10.1, 20.1, 30.1]
}

const BODY_LENGTH_5 = [
  '+0.1/-0.3',
  '+0.15/-0.4',
  '+0.25/-0.5',
  '+0.3/-0.75',
  '+0.5/-1',
  '+0.75/-1.5',
  '+1/-2',
  '+1,5/-3',
  '+2/-4',
  '+2.5/-5',
  '+3/-6'
]

const BODY_LENGTH_RANGE_5 = {
  byLength: [16, 30, 50, 75, 100, 150, 200, 300, 400, 500]
}

// Для типов "Пружины растяжения", 'Пружина кручения', 'Торсионная пружина'
const WIRE_DIAMETER_TOLERANCE = [0.02, 0.025, 0.04, 0.08, 0.16, 0.24, 0.6, 0.8]

const BODY_LENGTH_RANGE_TYPE239 = {
  byDWire: [0.31, 0.61, 1.41, 3.1, 6.1, 12.1, 25.1],
  byTurns: [6.31, 10.01, 16.01, 25.01]
}

const BODY_LENGTH_TYPE239 = [
  [0.5, 0.35, 0.2, 0.25, 0.25, 0.2, 0.2, 0.15],
  [0.75, 0.5, 0.3, 0.5, 0.5, 0.3, 0.3, 0.2],
  [1.5, 1, 0.5, 0.75, 0.75, 0.5, 0.5, 0.3],
  [2.25, 1.5, 0.75, 1, 1, 0.75, 0.75, 0.5],
  [0.1, 0.07, 0.04, 0.05, 0.05, 0.04, 0.04, 0.025]
]

export {
  BODY_LENGTH,
  BODY_LENGTH_RANGE,
  BODY_LENGTH_5,
  BODY_LENGTH_RANGE_5,
  WIRE_DIAMETER_TOLERANCE,
  BODY_LENGTH_RANGE_TYPE239,
  BODY_LENGTH_TYPE239,
  BODY_LENGTH_FOR_S3,
  BODY_LENGTH_RANGE_FOR_S3,
  BODY_LENGTH_TYPE1,
  BODY_LENGTH_RANGE_TYPE1,
  BODY_LENGTH_DWIRE_SPLIT_VALUE
}
